import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import ApolloPage from './pages/ApolloPage';
import AffirmPage from './pages/AffirmPage';
import EpicGamesPage from './pages/EpicGamesPage';
import ThredUpPage from './pages/ThredUpPage';
import RapToBeatsPage from './pages/RapToBeatsPage';
import ScoutForcePage from './pages/ScoutForcePage';
import SocialsPage from './pages/SocialsPage';
import Resume from './pages/Resume';
import MyStoryPage from './pages/MyStoryPage';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="w-full" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/portfolio/apollo" element={<ApolloPage data-id="element-7" />} data-id="element-6" />
          <Route path="/portfolio/affirm" element={<AffirmPage data-id="element-9" />} data-id="element-8" />
          <Route path="/portfolio/epic-games" element={<EpicGamesPage data-id="element-11" />} data-id="element-10" />
          <Route path="/portfolio/thredup" element={<ThredUpPage data-id="element-13" />} data-id="element-12" />
          <Route path="/portfolio/rap-to-beats" element={<RapToBeatsPage data-id="element-15" />} data-id="element-14" />
          <Route path="/portfolio/scoutforce" element={<ScoutForcePage data-id="element-17" />} data-id="element-16" />
          <Route path="/socials" element={<SocialsPage data-id="element-19" />} data-id="element-18" />
          <Route path="/resume" element={<Resume data-id="element-21" />} data-id="element-20" />
          <Route path="/my-story" element={<MyStoryPage data-id="element-23" />} data-id="element-22" />
        </Routes>
      </main>
    </div>;
}